
export const Loader: React.FC = ()=> {
    return (
        <div className='bg-reference-item w-100 me-3 br-16 p-3'>
            <div className='d-flex g-2'>
                <div style={{height:'16px', width:'30px'}} className='shimmer-loader'></div>
                <div style={{height:'16px', width:'300px'}} className='shimmer-loader'></div>
            </div>
            <div className='d-flex d-flex-column g-2 mt-3'>
                <div style={{height:'16px', width:'200px'}} className='shimmer-loader'></div>
                <div style={{height:'14px', width:'100%'}} className='shimmer-loader'></div>
                <div style={{height:'14px', width:'100%'}} className='shimmer-loader'></div>
                <div style={{height:'14px', width:'100%'}} className='shimmer-loader'></div>
            </div>
        </div>
    )
}